<template>
    <div>
        <main>
            <v-text-field
                requried
                label="Título"
                v-model="title"
                :disabled="permission.write?null:true">
            </v-text-field>
            <v-label>Imagem abaixo do título</v-label>
            <fluke-imageuploader v-model="img" :disabled="permission.write?null:true"></fluke-imageuploader>
            <v-text-field
                label="Meta Tags"
                v-model="meta_tags"
                :disabled="permission.write?null:true">
            </v-text-field>
            <v-textarea
                label="Meta Description"
                rows="1"
                auto-grow
                v-model="meta_description"
                :disabled="permission.write?null:true">
            </v-textarea>
            <br>
            <v-select
                v-model="selectedCategories"
                :items="categories"
                item-text="category"
                item-value="id"
                :menu-props="{ maxHeight: '400' }"
                label="Categorias"
                multiple
                class="half"
                :disabled="permission.write?null:true">
            </v-select>
            <br>
            <br>
            <label class="fluke-editor-label">Conteúdo</label>
            <fluke-editor :disabled="permission.write?null:true" v-model="post" :key="keyer" />
            <div class="flexsplit">
                <div>
                    <v-text-field
                        label="Resumo"
                        v-model="resume"
                        counter
                        maxlength="125"
                        :disabled="permission.write?null:true">
                    </v-text-field>
                    <br>
                    <v-combobox
                        v-model="tags"
                        label="Tags"
                        chips
                        clearable
                        multiple
                        class="tagcombo"
                        :disabled="permission.write?null:true">
                    </v-combobox>
                </div>
                <fluke-imageuploader v-model="thumb" :disabled="permission.write?null:true"></fluke-imageuploader>
            </div>
        </main>
        <footer>
            <fluke-button v-on:click.native="cancel" color="grey">Cancelar</fluke-button>
            <fluke-button v-on:click.native="submit" v-if="permission.write">Salvar</fluke-button>
        </footer>
    </div>
</template>

<script>

import Button from '../../components/Main/Content/Button/Button.vue';
import Editor from '../../components/Main/Content/Editor/Editor';
import ImageUploader from '../../components/Main/Content/ImageUploader/ImageUploader';

export default {
    components: {
        'fluke-button': Button,
        'fluke-editor': Editor,
        'fluke-imageuploader': ImageUploader
    },
    props: {
        permission: {
            type: Object,
            required: true,
        },
        categories: {
            type: Array,
            required: true,
        },
        initialData: {
            type: Object,
        },
    },
    data: function() {
        return {
            id: null,
            title: '',
            meta_tags: '',
            meta_description: '',
            post: '',
            img: '',
            keyer: 0,
            resume: '',
            thumb: '',
            tags: [],
            selectedCategories: []
        }
    },
    methods: {
        setInitialData: function () {
            this.id = this.initialData.id
            this.title = this.initialData.title
            this.meta_tags = this.initialData.meta_tags
            this.meta_description = this.initialData.meta_description
            this.post = this.initialData.post
            this.img = this.initialData.img
            this.resume = this.initialData.resume
            this.thumb = this.initialData.thumb
            this.tags = this.initialData.tags
            this.selectedCategories = this.initialData.selectedCategories
            this.keyer += 1
        },
        submit: async function() {
            const data = {
                id: this.id,
                title: this.title,
                meta_tags: this.meta_tags,
                meta_description: this.meta_description,
                post: this.post,
                img: this.img,
                resume: this.resume,
                thumb: this.thumb,
                tags: this.tags,
                selectedcategories: this.selectedCategories,
            };
            this.$emit('submit', data);
        },
        cancel: function() {
            this.$emit('cancel');
        },
    },
    watch: {
        initialData: function (value) {
            if (value) {
                this.setInitialData()
            }
        }
    }
}
</script>
